<template>
    <a href="#" @click="click">
        <slot />
    </a>
</template>

<script>
import { isEmpty } from "@/utils/functions"

export default {
    name: 'ExternalLink',
    props: [
        "to"
    ],
    methods: {
        click() {
            if (isEmpty(this.to)) {
                return;
            }
            
            window.location.href = this.to
        }
    }
}
</script>
